import isMobile from '$/utils/isMobile';

export const PlayButtonSizePx = isMobile ? 60 : 80;
